module.exports = __webpack_public_path__ + "static/media/FondoBlanco.d69dfeb9.jpg";